/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { asField, Checkbox } from "informed";
import validatehoc from "../Validator";

class CheckBox extends Component {
	CheckboxInput = validatehoc(
		asField(({ fieldState, ...props }) => {
			const { label } = this.props;
			const { error } = fieldState;
			const hasError = error ? "has-error" : "";
			return (
				<Fragment>
					<Checkbox fieldState={fieldState} {...props} className={hasError} />
					{label}
					{error ? (
						<div>
							<small className="error-message">{error}</small>
						</div>
					) : null}
				</Fragment>
			);
		}),
		"bool"
	);

	render() {
		const { fieldState, label, id, isRequired } = this.props;
		let align = "ta-left";
		const { error } = fieldState;
		const hasError = error ? "has-error" : "";
		if (this.props.textalign) {
			align = `ta-${this.props.textalign}`;
		}
		return (
			<div className={`checkbox-wrap ${align} ${hasError}`}>
				<label htmlFor={id}>
					<Fragment>
						<Checkbox fieldState={fieldState} {...this.props} className={hasError} />
						<div className="checkbox-label">
							{label}
							{isRequired && <span className="isrequired-label">*</span>}
							<br />
							{error ? <span className="error-message caption-text">{error}</span> : null}
						</div>
					</Fragment>
				</label>
			</div>
		);
	}
}

CheckBox.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	label: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	textalign: PropTypes.string,
	fieldState: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <CheckBox fieldState={fieldState} {...props} />),
	"bool"
);

export default Wrapper;
